<template>
	<div class="cards-group width-100">
		<div v-for="(project, indx) in projects" :key="`${project.id}__${indx}`" class="mr-3 mb-2 card">
			<ProjectDetailsCard :isVirtual="isVirtual" :project="project" :fetchData="false" />
		</div>
	</div>
</template>

<script>
import ProjectDetailsCard from '@/components/Project/ProjectDetailsCard.vue';
export default {
	name: 'ProjectDetailsCardGroup',
	props: {
		projects: { type: Array },
		isVirtual: { type: Boolean },
	},
	components: {
		ProjectDetailsCard,
	},
};
</script>

<style scoped lang="scss">
.cards-group {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
</style>
